import { useEffect, useState } from "react";
import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import ShimoSection from "./components/ShimoSection";
import TimelineSection from "./components/TimelineSection";
import FactCheckSection from "./components/FactCheckSection";
import TermGridSection from "./components/TermGridSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href="#hero"
      aria-label="回到顶部"
      className={`fixed bottom-6 right-6 z-50 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-none transition-all hover:bg-primary-600 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <i className="ri-arrow-up-line text-lg w-5 h-5 flex items-center justify-center" />
    </a>
  );
}

export default function Home() {
  return (
    <main className="w-full min-h-screen bg-background-50">
      <TopNav />
      <Hero />
      <IntroSection />
      <ShimoSection />
      <TimelineSection />
      <FactCheckSection />
      <TermGridSection />
      <FaqSection />
      <AboutSection />
      <Footer />
      <BackToTop />
    </main>
  );
}